import styled from "styled-components";

export const StyledWrapper = styled.div`
  max-width: 528px;
  width: 100%;
  border-radius: 5px;
  background: #f9fafb;
  margin: auto;
  border: 2px solid #e5e7eb;
`;